<p *ngIf="langue.l == 'fr'">
    Pour créer un personnage dans Destalyr, il est suggéré de commencer par la race ou la magie.<br/>
    Chaque race possède des bonus et des limitations sur certaines statistiques de jeu, et la magie est un point important de l'univers.<br/>
    Note : Les races ont des affinités naturelles,
    donc un personnage d'une certaine race va avoir tendance a posséder la magie de sa race en majeure (ou au moins mineure).<br/>
    Les exceptions existent, mais sont rares et demandent une explication
    (grandit autre part, en confrontation avec son environnement, illumination, mentor externe, ...).
</p>
<p *ngIf="langue.l == 'en'">
    To create a character in Destalyr, it is suggested to start with a race or a magic.<br/>
    Each race has bonuses and limitations on game stats, and the magic is a big part of the world.<br/>
    Note : The races have natural affinities,
    therefore a character of a certain race will tend to have the race's magic as major or minor.<br/>
    Exceptions exist, but are rare and require an explanation
    (grew up someplace else, in conflict with one's environment, illumination, external mentor, ...).
</p>

<div class="div-table" *ngIf="langue.l == 'fr'">
    <table>
        <tr>
            <th>Race</th>
            <th>+1 au choix</th>
            <th>Cap à 2</th>
            <th>Capacité passive</th>
            <th>Capacité active</th>
        </tr>
        <tr>
            <td>Nekali</td>
            <td>Agilité / Perception</td>
            <td>Force</td>
            <td>Grimper</td>
            <td>Attaquer avec ses griffes (attaque légère tranchante)</td>
        </tr>
        <tr>
            <td>Flyhn</td>
            <td>Force / Perception</td>
            <td>Dextérité</td>
            <td>Planner</td>
            <td>+2 pour sauter (plus haut, plus loin)</td>
        </tr>
        <tr>
            <td>Elf Sylvain</td>
            <td>Dextérité / Éloquence</td>
            <td>Résistance</td>
            <td>Comprendre les instincts des êtres vivants non sensés</td>
            <td>Communications dans les 2 sens avec les êtres vivants non sensés</td>
        </tr>
        <tr>
            <td>Etrek</td>
            <td>Force / Résistance</td>
            <td>Agilité</td>
            <td>Purifier de l'eau</td>
            <td>Enracinement (+1 force, +1 res, et 0 movement quand actif, 2PA switch on/off)</td>
        </tr>
        <tr>
            <td>Elf Sombre</td>
            <td>Dextérité / Agilité</td>
            <td>Éloquence</td>
            <td>Vision dans le noir total</td>
            <td>Se cacher magiquement dans les ombres</td>
        </tr>
        <tr>
            <td>Lyune</td>
            <td>Oui</td>
            <td>Non</td>
            <td>+1 éloquence</td>
            <td>minimum 6 au dé pour négocier / calmer</td>
        </tr>
    </table>
</div>
<div class="div-table" *ngIf="langue.l == 'en'">
    <table>
        <tr>
            <th>Race</th>
            <th>+1 to choose</th>
            <th>Max 2</th>
            <th>Special ability</th>
        </tr>
        <tr>
            <td>Nekali</td>
            <td>Agility / Perception</td>
            <td>Strength</td>
            <td>Climbing</td>
        </tr>
        <tr>
            <td>Flyhn</td>
            <td>Strength / Perception</td>
            <td>Dexterity</td>
            <td>Glide</td>
        </tr>
        <tr>
            <td>Wood elf</td>
            <td>Eloquence / Dexterity</td>
            <td>Resistance</td>
            <td>Basic communication with living non sensible beings</td>
        </tr>
        <tr>
            <td>Etrek</td>
            <td>Strength / Resistance</td>
            <td>Agility</td>
            <td>Purifiy water + rooting</td>
        </tr>
        <tr>
            <td>Dark elf</td>
            <td>Dexterity / Agility</td>
            <td>Eloquence</td>
            <td>Actual darkvision</td>
        </tr>
        <tr>
            <td>Lyune</td>
            <td>Yes</td>
            <td>No</td>
            <td>Not being hated</td>
        </tr>
    </table>
</div>

<p *ngIf="langue.l == 'fr'">
    Ensuite il faut répartir les points sur les différentes statistiques.<br/>
    La sensitivité est égale au niveau du personnage, ne peut pas recevoir de bonus ou de malus, et évolue avec la progression du personnage.
    Le joueur possède ensuite 6 valeurs à répartir sur les 6 stats restantes : 1 - 2 - 2 - 3 - 4 - 5<br/>
    Après la répartition, le joueur peut ajouter son point de stat racial, et vérifier que sa limitation est respectée,
    sinon la stat limitée est baissée à 2 pour respecter.<br/>
    Ensuite, il faut décider de quel background le personnage vient et quelle éducation le personnage a reçu.
    De manière générale, le personnage commence avec 3 points de compétence.<br/>
    Les points de compétence peuvent être dépensés sur un des trois arbres de
    <a routerLink="/character/skills" routerLinkActive="activebutton">compétence</a>.
    Chaque bloc coûte un point à apprendre et nécessite (au moins) un bloc parent connu (suivre les flèches).
    Certains blocs de compétences comprennent plusieurs niveaux (entre 1 et 3).
    Les points additionnels investis dans le même bloc augmente le niveau de la compétence, dans la limite du niveau maximum indiqué.<br/>
    Les arbres sont indépendents et un personnage peut aller dans les trois arbres sans restrictions.
    Les points sont communs à tous les arbres, et une fois consommés ne peuvent pas être ré-utilisés.<br/>
    <b>Exemples</b> :<br/>
    Personnage A veut être un mage sans armure. Il met ses trois points dans l'arbre magie.<br/>
    Personnage B veut être un archer en armure légère.
    Il met deux points en attaque côté armes de distance et un point en défense pour l'armure légère.<br/>
    Personnage C veut porter une armure lourde. Il met deux points en défense,
    et n'a plus qu'un point à mettre en attaque, qu'il met pour pouvoir manipuler les armes de mêlée.<br/>
    <br/>
    Enfin, le personnage peut posséder des connaissances sur des sujets variés.
    Les connaissances est une partie entièrement ouverte et personalisable du personnage
    (tant que ça reste dans le thème général du monde aka médiéval fantasy).<br/>
</p>
<p *ngIf="langue.l == 'en'">

</p>

<h3>Gagner des niveaux</h3>


<p *ngIf="langue.l == 'fr'">
  Résumé de création de perso<br/>
  niveau 0 (sensitivité = 0):<br/>
  - stats 1-2-2-3-4-5, +1 de race.<br/>
  - compétences (= skill) : 3<br/>
  - connaissances : 1<br/>
  - spécialisation : 1<br/>
  - PA max : 5<br/>
  Ces valeurs vont augmenter avec l'expérience du personnage,
  et la limitation de 2 dans une stat causée par le choix de la race ne s'applique pas aux gains de niveaux, seulement à la création (niveau 0).<br/>
  Suggestion de progression :<br/>
  niveau 1 : +1 skill +1 spec (et sensitivité = 1)<br/>
  niveau 2 : +1 skill +1 stat (et sensitivité = 2) etc.<br/>
  niveau 3 : +1 skill +1 PA max<br/>
  niveau 4 : +1 skill +1 spec<br/>
  niveau 5 : +1 skill +1 stat<br/>
  niveau 6 : +1 skill +1 PA max<br/>
  niveau 7 : +1 skill +1 spec<br/>
  niveau 8 : +1 skill +1 stat<br/>
  niveau 9 : +1 skill +1 PA max<br/>
  Après le niveau 9, le cycle peut continuer à se répéter mais sans augmenter la sensitivité.
  A la place, les lignes paires du tableau des effets magiques se suppriment une à une, et les valeurs se décalent. <br>
  Par exemple au niveau 11 (9+2) les lignes 2 et 4 sont supprimées.
  Donc le 1 garde ses effets, une valeur de 2 aura les effets de la ligne 3, et une valeur de 3 aura les effets de la ligne 5.
  Le 4 aura les effets de la ligne 6 et le reste continue ligne par ligne. <br>
  Cela permet aux sorts d'avoir des effets plus forts sans coûter plus d'énergie.<br>
  <br>
  Gagner de nouvelles connaissances est plus lié aux expériences et choix du personnage qu'à son niveau,
  mais une quantité suggérée (pour l'équilibre) est de donner environ une connaissance tout les 3 niveaux.
</p>

<p *ngIf="langue.l == 'en'">

</p>
